


import Vue from 'vue';
import VueRouter from 'vue-router';
import ls from 'local-storage';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { 
      path: '/:company_id/classification', 
      name: 'avaliation', 
      component:  () => import('@/components/SearchClassification.vue'),
      props: true 
    },
    
    { 
      path: '/register-company', 
      beforeEnter: ifIsAuthenticated,
      name: 'register-company', 
      component:  () => import('@/views/ListCompanies.vue'),
      props: true 
    },
    { 
      path: '/dashboard', 
      beforeEnter: ifIsAuthenticated,
      name: 'dashboard', 
      component:  () => import('@/components/Dashboard.vue'),
      props: true 
    },
    { 
      path: '/companies', 
      beforeEnter: ifIsAuthenticated,
      name: 'company', 
      component:  () => import('@/views/Avaliation.vue'),
      props: true 
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
      },
    },

    {
      path: '*',
      redirect: 'dashboard',
    },
  ],
});

function ifIsAuthenticated(to, from, next) {
  if (ls.get('t')) {
    next();
  } else {
    next({ name: 'login' });
  }
}


router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

export default router;
